import { useState } from "react";

import SideBar from "../../ui/SideBar";

import {
  Container,
  Content,
  Icon,
  Navigation,
  SideBarContainer,
} from "./styles";

import Logo from "../../../assets/images/branding/logo-primary.svg";
import MenuIcon from "../../../assets/images/icons/menu.svg";

const Header = () => {
  const [sideBarShow, setSideBarShow] = useState(false);

  const showSideBar = () => {
    setSideBarShow(!sideBarShow);
  };

  return (
    <Container>
      <Content>
        <img src={Logo} alt="logo" />

        <Navigation>
          <ul>
            <li>
              <a href="#aboutUs">Quem Somos</a>
            </li>
            <li>
              <a href="#realmadrid">Arena Ibirapuera</a>
            </li>
            <li>
              <a href="#academy">ESP Academy</a>
            </li>
            <li>
              <a href="#esp">ESP Experience</a>
            </li>
            <li>
              <a href="#social">ESP Social</a>
            </li>
            <li>
              <a href="#realmadrid">Fundação Real Madrid</a>
            </li>
            <li>
              <a href="#form">Contato</a>
            </li>
          </ul>
        </Navigation>

        <SideBarContainer>
          <Icon src={MenuIcon} alt="icone" onClick={showSideBar} />
          {sideBarShow && <SideBar active={setSideBarShow} />}
        </SideBarContainer>
      </Content>
    </Container>
  );
};

export default Header;
